async function get(url) {
    return fetch(`${process.env.NODE_ENV === "development" ? "http://localhost:8092" : "https://server.a2021.slmn.io" }${url}`).then(res => res.json());
}

export async function getCompanion(companionKey) {
    return await get(`/companion/${companionKey}`);
}
